import axios from 'axios';
const BASE = window.location.hostname === 'localhost' ? 'http://localhost:5001/api' : '/api';
const api = axios.create({ baseURL: BASE, timeout: 15000, headers: { 'Content-Type': 'application/json' } });

// Aktif sayfa heartbeat — MainLayout setActivePage çağırınca güncellenir.
// Her istekte X-Active-Page header'ı olarak backend'e gider.
let _activePage = null;
export function setActivePageHeader(page) { _activePage = page || null; }

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('erp_token');
  if (token) config.headers.Authorization = 'Bearer ' + token;
  if (_activePage) config.headers['X-Active-Page'] = _activePage;
  return config;
});
api.interceptors.response.use((r) => r, (error) => { if (error.response && error.response.status === 401) { localStorage.removeItem('erp_token'); window.location.href = '/login'; } return Promise.reject(error); });
export default api;
